import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { withRouter } from 'react-router-dom';
import { fabric } from "fabric";

const wbWidth = 1366;
const wbHeight = 768;

let whiteboard;
let whiteboardHeader;
let wbDrawingColorEl;
let wbBackgroundColorEl;
let whiteboardPencilBtn;
let whiteboardObjectBtn;
let whiteboardUndoBtn;
let whiteboardRedoBtn;
let whiteboardImgFileBtn;
let whiteboardImgUrlBtn;
let whiteboardTextBtn;
let whiteboardLineBtn;
let whiteboardRectBtn;
let whiteboardCircleBtn;
let whiteboardSaveBtn;
let whiteboardEraserBtn;
let whiteboardCleanBtn;
let whiteboardCloseBtn;
// whiteboard settings
let wbCanvas = null;
let wbIsDrawing = false;
let wbIsOpen = false;
let wbIsRedoing = false;
let wbIsEraser = false;
let wbPop = [];


class WhiteBoard extends React.Component {


  state = {
  }





  componentDidMount() {

    let whiteboard = document.getElementById('whiteboard')
    let whiteboardHeader = document.getElementById('whiteboardHeader')

    this.dragElement(whiteboard, whiteboardHeader);

    this.setupWhiteboard()
  }



  /**
  * Whiteboard: handle actions
  * @param {object} config data
  * @param {boolean} logme popup action
  */
  handleWhiteboardAction = (config, logme = true) => {
    if (logme) {
      console.log('toast', `${config.peer_name} whiteboard action: ${config.action}`);
    }
    switch (config.action) {
      case 'bgcolor':
        this.wbCanvasBackgroundColor(config.color);
        break;
      case 'undo':
        this.wbCanvasUndo();
        break;
      case 'redo':
        this.wbCanvasRedo();
        break;
      case 'clear':
        wbCanvas.clear();
        break;
      case 'toggle':
        this.toggleWhiteboard();
        break;
      //...
    }
  }


  /**
  * Whiteboard: set background color
  * @param {string} color to set
  */
  wbCanvasBackgroundColor = (color) => {

    document.documentElement.style.setProperty('--wb-bg', color);
    wbBackgroundColorEl.value = color;
    wbCanvas.setBackgroundColor(color);
    wbCanvas.renderAll();
  }


  changeColor = (e) => {
    console.log(e.target.value)
    let bg = document.getElementById('whiteboard');
    bg.style.background = e.target.value
  }

  changePenColor = (e) => {
    wbCanvas.freeDrawingBrush.color = e.target.value;
    this.whiteboardIsDrawingMode(true);
  }



  /**
  * Whiteboard: undo
  */
  wbCanvasUndo = () => {
    if (wbCanvas._objects.length > 0) {
      wbPop.push(wbCanvas._objects.pop());
      wbCanvas.renderAll();
    }
  }

  /**
  * Whiteboard: redo
  */
  wbCanvasRedo = () => {
    if (wbPop.length > 0) {
      wbIsRedoing = true;
      wbCanvas.add(wbPop.pop());
    }
  }

  /**
  * Whiteboard: Show-Hide
  */
  toggleWhiteboard = () => {
    // if (!wbIsOpen) playSound('newMessage');
    whiteboard.classList.toggle('show');
    whiteboard.style.top = '50%';
    whiteboard.style.left = '50%';
    wbIsOpen = wbIsOpen ? false : true;
  }


  /**
  * Make Obj draggable: https://www.w3schools.com/howto/howto_js_draggable.asp
  * @param {object} elmnt father element
  * @param {object} dragObj children element to make father draggable (click + mouse move)
  */
  dragElement = (elmnt, dragObj) => {
    let pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    if (dragObj) {
      // if present, the header is where you move the DIV from:
      dragObj.onmousedown = dragMouseDown;
    } else {
      // otherwise, move the DIV from anywhere inside the DIV:
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
      elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
    }

    function closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }









  /**
  * Whiteboard: https://github.com/fabricjs/fabric.js
  */

  //Todo this.dragElement(whiteboard, whiteboardHeader);

  //Todo setupWhiteboard();

  //         whiteboardPencilBtn.addEventListener('click', (e) => {
  //     whiteboardIsDrawingMode(true);
  // });

  /**
* Whiteboard: drawing mode
* @param {boolean} status of drawing mode
*/
  whiteboardIsDrawingMode = (status) => {
    wbCanvas.isDrawingMode = status;
    if (status) {
      // setColor(whiteboardPencilBtn, 'green');
      // setColor(whiteboardObjectBtn, 'white');
      // setColor(whiteboardEraserBtn, 'white');
      wbIsEraser = false;
    } else {
      // setColor(whiteboardPencilBtn, 'white');
      // setColor(whiteboardObjectBtn, 'green');
    }
  }


  /**
  * Whiteboard: setup canvas
  */
  setupWhiteboardCanvas = () => {
    wbCanvas = new fabric.Canvas('wbCanvas');
    console.log(wbCanvas)
    wbCanvas.freeDrawingBrush.color = '#000';
    wbCanvas.freeDrawingBrush.width = 3;
    this.whiteboardIsDrawingMode(true);
  }

  /**
  * Whiteboard: setup
  */
  setupWhiteboard = () => {
    this.setupWhiteboardCanvas();
    this.setupWhiteboardCanvasSize();
    this.setupWhiteboardLocalListners();
  }


  /**
* Whiteboard: canvas objects to json
*/
  wbCanvasToJson = () => {
    if (this.thereIsPeerConnections && this.thereIsPeerConnections()) {
      let config = {
        room_id: this.props?.roomId,
        wbCanvasJson: JSON.stringify(wbCanvas.toJSON()),
      };
      this.sendToServer('wbCanvasToJson', config);
    }
  }

  /**
   * If whiteboard opened, update canvas to all peers connected
   */
  wbUpdate = async () => {
    if (wbIsOpen && this.thereIsPeerConnections()) this.wbCanvasToJson();
  }

  /**
   * Whiteboard: json to canvas objects
   * @param {object} config data
   */
  handleJsonToWbCanvas = (config) => {
    if (!wbIsOpen);

    wbCanvas.loadFromJSON(config.wbCanvasJson);
    wbCanvas.renderAll();
  }

  /**
   * Whiteboard: actions
   * @param {string} action whiteboard action
   * @returns {object} data
   */
  getWhiteboardAction = (action) => {
    return {
      room_id: this.props?.roomId,
      peer_name: this.props.myPeerName,
      action: action,
    };
  }

  /**
   * Whiteboard: Local listners
   */
  setupWhiteboardLocalListners = () => {
    console.log("setupWhiteboardLocalListners")
    wbCanvas.on('mouse:down', (e) => {
      this.mouseDown(e);
    });
    wbCanvas.on('mouse:up', () => {
      this.mouseUp();
    });
    wbCanvas.on('mouse:move', () => {
      this.mouseMove();
    });
    wbCanvas.on('object:added', () => {
      this.objectAdded();
    });
  }


  /**
* Whiteboard: mouse down
* @param {object} e event
* @returns
*/
  mouseDown = (e) => {
    wbIsDrawing = true;
    if (wbIsEraser && e.target) {
      wbCanvas.remove(e.target);
      return;
    }
  }

  /**
   * Whiteboard: mouse up
   */
  mouseUp = () => {
    wbIsDrawing = false;
    this.wbCanvasToJson();
  }

  /**
   * Whiteboard: mouse move
   * @returns
   */
  mouseMove = () => {
    if (wbIsEraser) {
      wbCanvas.hoverCursor = 'not-allowed';
      return;
    } else {
      wbCanvas.hoverCursor = 'move';
    }
    if (!wbIsDrawing) return;
  }

  /**
   * Whiteboard: tmp objects
   */
  objectAdded = () => {
    if (!wbIsRedoing) wbPop = [];
    wbIsRedoing = false;
  }


  pencilBtn = () => {
    this.whiteboardIsDrawingMode(true);
  }

  arrowBtn = () => {
    this.whiteboardIsDrawingMode(false);
  }

  undoBtn = () => {

    /**
    * Whiteboard: undo
    */
    this.wbCanvasUndo = () => {
      if (wbCanvas._objects.length > 0) {
        wbPop.push(wbCanvas._objects.pop());
        wbCanvas.renderAll();
      }
    }

    this.wbCanvasUndo()
  }

  redoBtn = () => {
    /**
    * Whiteboard: redo
    */
    this.wbCanvasRedo = () => {
      if (wbPop.length > 0) {
        wbIsRedoing = true;
        wbCanvas.add(wbPop.pop());
      }
    }

    this.wbCanvasRedo()

  }

  cleanWhiteboard = () => {
    wbCanvas.clear();
  }

  eraserBtn = () => {
  }

  writeText = () => {
    // this.whiteboardAddObj('text');
    this.setState({ WriteText: !this.state.WriteText })
  }

  typeWordInCanvas = (e) => {
    this.text = e.target.value;
  }

  okayText = () => {
    this.whiteboardAddObj('text');
  }

  makeLine = () => {
    this.whiteboardAddObj('line');
  }

  makeCircle = () => {
    this.whiteboardAddObj('circle');
  }

  makeRect = () => {
    this.whiteboardAddObj('rect')
  }

  attachFile = () => {
    this.whiteboardAddObj('imgUrl');
  }

  chooseImage = () => {
    this.setState({ chooseImage: !this.state.chooseImage })
  }


  okaychooseImage = () => {
    this.whiteboardAddObj('imgFile');
  }

  imageValue = (e) => {
    this.imageAddress = e.target.files[0];
    console.log(this.imageAddress)
  }


  chooseUrl = () => {
    this.setState({ chooseUrl: !this.state.chooseUrl })
  }


  okaychooseImage = () => {
    this.whiteboardAddObj('imgUrl');
  }

  imageUrl = (e) => {
    this.imageUri = e.target.value;
  }


  /**
  * Whiteboard: add object
  * @param {object} obj to add
  */
  addWbCanvasObj = (obj) => {
    if (obj) {
      wbCanvas.add(obj);
      this.whiteboardIsDrawingMode(false);
      // wbCanvasToJson();
    }
  }


  /**
  * Check if url passed is a image
  * @param {string} url to check
  * @returns {boolean} true/false
  */
  isImageURL = (url) => {
    // return url.match(/\.(jpeg|jpg|gif|png|tiff|bmp)$/) != null;
  }

  /**
  * Whiteboard: Add object to canvas
  * @param {string} type of object to add
  */
  whiteboardAddObj = (type) => {
    switch (type) {
      case 'imgUrl':
        let wbCanvasImgURL = this.imageUri;
        if (this.isImageURL(wbCanvasImgURL)) {
          fabric.Image.fromURL(wbCanvasImgURL, function (myImg) {
            this.addWbCanvasObj(myImg);
          });
        } else {
          console.log('error', 'The URL is not a valid image');
        }
        break;
      case 'imgFile':
        console.log("img")
        let wbCanvasImg = this.imageAddress;
        if (wbCanvasImg && wbCanvasImg.size > 0) {
          let reader = new FileReader();
          reader.onload = (event) => {
            let imgObj = new Image();
            imgObj.src = event.target.result;
            console.log(imgObj)
            imgObj.onload = () => {
              let image = new fabric.Image(imgObj);
              console.log(image)
              image.set({ top: 0, left: 0 }).scale(0.3);
              this.addWbCanvasObj(image);
            };
          };
          reader.readAsDataURL(wbCanvasImg);
        }
        else {
          console.log('error', 'File not selected or empty');
        }
        break;
      case 'text':
        const text = new fabric.Text(this.text, {
          top: 0,
          left: 0,
          fontFamily: 'Comfortaa',
          fill: wbCanvas.freeDrawingBrush.color,
          strokeWidth: wbCanvas.freeDrawingBrush.width,
          stroke: wbCanvas.freeDrawingBrush.color,
        });

        this.addWbCanvasObj(text);

        break;
      case 'line':
        const line = new fabric.Line([50, 100, 200, 200], {
          top: 0,
          left: 0,
          fill: wbCanvas.freeDrawingBrush.color,
          strokeWidth: wbCanvas.freeDrawingBrush.width,
          stroke: wbCanvas.freeDrawingBrush.color,
        });
        this.addWbCanvasObj(line);
        break;
      case 'circle':
        const circle = new fabric.Circle({
          radius: 50,
          fill: 'transparent',
          stroke: wbCanvas.freeDrawingBrush.color,
          strokeWidth: wbCanvas.freeDrawingBrush.width,
        });
        this.addWbCanvasObj(circle);
        break;
      case 'rect':
        const rect = new fabric.Rect({
          top: 0,
          left: 0,
          width: 150,
          height: 100,
          fill: 'transparent',
          stroke: wbCanvas.freeDrawingBrush.color,
          strokeWidth: wbCanvas.freeDrawingBrush.width,
        });
        this.addWbCanvasObj(rect);
        break;
    }
  }



  /**
  * Whiteboard: setup size
  * @param {string} w width
  * @param {string} h height
  */
  setWhiteboardSize(w, h) {
    document.documentElement.style.setProperty('--wb-width', w);
    document.documentElement.style.setProperty('--wb-height', h);
  }


  /**
  * Whiteboard: setup canvas size
  */
  setupWhiteboardCanvasSize = () => {
    let optimalSize = [wbWidth, wbHeight];
    let scaleFactorX = window.innerWidth / optimalSize[0];
    let scaleFactorY = window.innerHeight / optimalSize[1];
    if (scaleFactorX < scaleFactorY && scaleFactorX < 1) {
      wbCanvas.setWidth(optimalSize[0] * scaleFactorX);
      wbCanvas.setHeight(optimalSize[1] * scaleFactorX);
      wbCanvas.setZoom(scaleFactorX);
      this.setWhiteboardSize(optimalSize[0] * scaleFactorX, optimalSize[1] * scaleFactorX);
    } else if (scaleFactorX > scaleFactorY && scaleFactorY < 1) {
      wbCanvas.setWidth(optimalSize[0] * scaleFactorY);
      wbCanvas.setHeight(optimalSize[1] * scaleFactorY);
      wbCanvas.setZoom(scaleFactorY);
      this.setWhiteboardSize(optimalSize[0] * scaleFactorY, optimalSize[1] * scaleFactorY);
    } else {
      wbCanvas.setWidth(optimalSize[0]);
      wbCanvas.setHeight(optimalSize[1]);
      wbCanvas.setZoom(1);
      this.setWhiteboardSize(optimalSize[0], optimalSize[1]);
    }
    wbCanvas.calcOffset();
    wbCanvas.renderAll();
  }



  // whiteboardObjectBtn.addEventListener('click', (e) => {
  //     whiteboardIsDrawingMode(false);
  // });
  // whiteboardUndoBtn.addEventListener('click', (e) => {
  //     whiteboardAction(getWhiteboardAction('undo'));
  // });
  // whiteboardRedoBtn.addEventListener('click', (e) => {
  //     whiteboardAction(getWhiteboardAction('redo'));
  // });
  // whiteboardSaveBtn.addEventListener('click', (e) => {
  //     wbCanvasSaveImg();
  // });
  // whiteboardImgFileBtn.addEventListener('click', (e) => {
  //     whiteboardAddObj('imgFile');
  // });
  // whiteboardImgUrlBtn.addEventListener('click', (e) => {
  //     whiteboardAddObj('imgUrl');
  // });
  // whiteboardTextBtn.addEventListener('click', (e) => {
  //     whiteboardAddObj('text');
  // });
  // whiteboardLineBtn.addEventListener('click', (e) => {
  //     whiteboardAddObj('line');
  // });
  // whiteboardRectBtn.addEventListener('click', (e) => {
  //     whiteboardAddObj('rect');
  // });
  // whiteboardCircleBtn.addEventListener('click', (e) => {
  //     whiteboardAddObj('circle');
  // });
  // whiteboardEraserBtn.addEventListener('click', (e) => {
  //     whiteboardIsEraser(true);
  // });
  // whiteboardCleanBtn.addEventListener('click', (e) => {
  //     confirmCleanBoard();
  // });
  // whiteboardCloseBtn.addEventListener('click', (e) => {
  //     handleWhiteboardToggle();
  // });
  // wbDrawingColorEl.addEventListener('change', (e) => {
  //     wbCanvas.freeDrawingBrush.color = wbDrawingColorEl.value;
  //     whiteboardIsDrawingMode(true);
  // });
  // wbBackgroundColorEl.addEventListener('change', (e) => {
  //     let config = {
  //         room_id: roomId,
  //         peer_name: myPeerName,
  //         action: 'bgcolor',
  //         color: wbBackgroundColorEl.value,
  //     };
  //     whiteboardAction(config);
  // });






  render() {
    return (
      <section id="whiteboard" class={"whiteboard active-whiteboard w-100 h-100"}>
        <header id="whiteboardHeader" class="whiteboard-header">
          <div style={{ display: "none" }} id="whiteboardTitle" class="whiteboard-header-title">
            <button id="whiteboardCloseBtn" class="fas fa-times"></button>
          </div>
          <div class="whiteboard-header-options">
            {/* <div className="screen-btn" onClick={() => this.onShowWhiteboard()}>
                  <img src="/assets/icons/rooms/screen.svg" alt="" />
              </div> */}
            <input ref={bg => this.backgroundEl = bg} className="whiteboardColorPicker" type="color" value="#000" onChange={(e) => this.changeColor(e)} />
            <input ref={pe => this.penColor = pe} id="wbDrawingColorEl" className="whiteboardColorPicker" type="color" value="#000" onChange={(e) => this.changePenColor(e)} />
            <button onClick={() => this.pencilBtn()}>
              <img className="flexcc" src="/assets/icons/rooms/pen.svg" alt="" />
            </button>
            <button onClick={() => this.arrowBtn()}>
              <img className="flexcc" src="/assets/icons/rooms/point.svg" alt="" />
            </button>
            <button onClick={() => this.undoBtn()}>
              <img className="flexcc" src="/assets/icons/rooms/undo.svg" alt="" />
            </button>
            <button onClick={() => this.redoBtn()}>
              <img className="flexcc" src="/assets/icons/rooms/redo.svg" alt="" />
            </button>
            <button onClick={() => this.chooseImage()}>
              <img className="flexcc" src="/assets/icons/rooms/picture.svg" alt="" />
            </button>
            <button onClick={() => this.attachFile()}>
              <img className="flexcc" src="/assets/icons/rooms/link.svg" alt="" />
            </button>
            <button onClick={() => this.writeText()}>
              <img className="flexcc" src="/assets/icons/rooms/text.svg" alt="" />
            </button>
            <button onClick={() => this.makeLine()}>
              <img className="flexcc" src="/assets/icons/rooms/line.svg" alt="" />
            </button>
            <button onClick={() => this.makeRect()}>
              <img className="flexcc" src="/assets/icons/rooms/circle.svg" alt="" />
            </button>
            <button onClick={() => this.makeCircle()}>
              <img className="flexcc" src="/assets/icons/rooms/squre.svg" alt="" />
            </button>
            <button onClick={() => this.saveCanvas()}>
              <img className="flexcc" src="/assets/icons/rooms/save.svg" alt="" />
            </button>
            <button onClick={() => this.eraserBtn()}>
              <img className="flexcc" src="/assets/icons/rooms/earse.svg" alt="" />
            </button>
            <button onClick={() => this.cleanWhiteboard()}>
              <img className="flexcc" src="/assets/icons/rooms/trash.svg" alt="" />
            </button>
          </div>
        </header>
        <main>
          <canvas id="wbCanvas"></canvas>
        </main>
        <div className={this.state.WriteText ? "writeInWhiteBoard active-Wib" : "writeInWhiteBoard deactive-Wib"}>
          <input type="text" name="" id="" onChange={(e) => this.typeWordInCanvas(e)} />
          <button onClick={() => this.okayText()}>okay</button>
          <button onClick={() => this.setState({ WriteText: false })}>cancel</button>
        </div>

        <div className={this.state.chooseImage ? "ask-name active-a" : "ask-name deactive-a"}>
          <input type="file" name="name" onChange={(e) => this.imageValue(e)} />
          <button onClick={() => this.okaychooseImage()}>okay</button>
          <button onClick={() => this.setState({ chooseImage: false })}>cancel</button>
        </div>

        <div className={this.state.chooseUrl ? "ask-name active-a" : "ask-name deactive-a"}>
          <input type="file" name="name" onChange={(e) => this.imageUrl(e)} />
          <button onClick={() => this.okaychooseurl()}>okay</button>
          <button onClick={() => this.setState({ chooseUrl: false })}>cancel</button>
        </div>
      </section>
    );
  }


}



const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WhiteBoard));
